<template>
	<layout-admin>
		<header-general :company-data="company" />
		<banner
			:company-data="company"
			:id="sectionsData.id"
			:banners="sections.banners"
			:is-mounted="isMounted"
			@banner-updated="loadSections" 
			v-if="!dataBanner.newbanner || editable" />

		<banner-custom  v-if="dataBanner.newbanner || editable" />
		
		<section-business />
		<app-tab
			:tabs="sections.about"
			@section-updated="loadSections" />
		<media
			v-if="video"
			:video="video" />
		<app-tab
			:tabs="sections.history"
			@section-updated="loadSections" />
		<experience />
	</layout-admin>
</template>

<script>
import appTab from '@/components/commons/app-tab';
import banner from '@/components/home/banner';
import bannerCustom from '@/components/home/banner-custom';
import experience from '@/components/home/experience';
import headerGeneral from '@/components/commons/header';
import media from '@/components/home/media';
import sectionBusiness from '@/components/home/business';

const computed = {
	video() {
		const { company } = this.$store.state;
		const video = company && company.linkText[0].length ? company.linkText[0] : null;
		return video;
	},
};

function mounted() {
	this.loadData();
	this.loadSections();
	
	const { company } = this.$store.state;
	this.dataBanner = company.credentialsMail;

}

async function loadData() {
	const { data: company } = await this.$http.get(
		`company/${process.env.COMPANY_CODE}/app/${process.env.APP_CODE}`);
	const newCompany = { ...company.data };
	newCompany.latitude = Number(company.data.latitude);
	newCompany.longitude = Number(company.data.longitude);
	this.company = { ...newCompany };
	this.$store.commit('SET_COMPANY', this.company);
	this.$bus.$emit('get-company', this.company);
}

async function loadSections() {
	this.isMounted = false;
	const CODE_PAGE = 1;
	const { data: sections } = await this.$http.get(`pages/${CODE_PAGE}`);
	this.sectionsData = { ...sections.data };
	const newSections = { ...this.sectionsData.dataSections };
	const newBanners = newSections.home ?
		newSections.home.images.map((i, index) => {
			const newBanner = {
				id: index + 1,
				img: i,
			};
			return newBanner;
		}) : [];
	newSections.banners = newBanners;
	newSections.about.name = 'about';
	newSections.history.name = 'history';
	newSections.about.id = this.sectionsData.id;
	newSections.history.id = this.sectionsData.id;
	const aboutKeys = Object.keys(newSections.about);
	const historyKeys = Object.keys(newSections.history);
	aboutKeys.forEach((key) => {
		if (key !== 'images' && key !== 'name' && key !== 'id') {
			newSections.about[key].images[0] = newSections.about[key].images[0] ||
				newSections.about.images[0];
		}
	});
	historyKeys.forEach((key) => {
		if (key !== 'images' && key !== 'name' && key !== 'title' && key !== 'id') {
			newSections.history[key].images[0] = newSections.history[key].images[0] ||
				newSections.history.images[0];
		}
	});
	this.sections = newSections;
	this.isMounted = true;
}

function data() {
	return {
		company: {},
		isMounted: false,
		sections: {
			about: {},
			banners: [],
			history: {},
		},
		sectionsData: {},
		showBanners: false,
		dataBanner: [],
	};
}

export default {
	name: 'page-home',
	computed,
	mounted,
	data,
	components: {
		appTab,
		banner,
		bannerCustom,
		experience,
		headerGeneral,
		media,
		sectionBusiness,
	},
	methods: {
		loadData,
		loadSections,
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/page-home.vue